export { SysqueTooltipModule } from './sysque-tooltip.module';
export { SysqueTooltipComponent } from './sysque-tooltip.component';